import * as React from "react";
import {Fragment} from "react";
import {none, Option, option} from "ts-option";
import IconLarge from "../../../../hiberUiKit/src/atoms/Icon/IconLarge";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import AssetSpecification, {AssetSpecificationLabel, AssetSpecificationType} from "../../../../model/asset/AssetSpecification";
import DictionaryItem from "../../../../model/dictionary/DictionaryItem";
import ButtonSecondary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonSecondary";
import SelectDictionaryItem from "../../common/select/SelectDictionaryItem";
import AssetSpecificationEfficiencySelector from "./AssetSpecificationEfficiencySelector";
import AssetSpecificationTextSelector from "./AssetSpecificationTextSelector";
import AssetSpecificationBooleanSelector from "./AssetSpecificationBooleanSelector";

interface Props {
	items: AssetSpecification[]
	onChange: (value: AssetSpecification[]) => void
}

interface State {
	filteredDictItems: DictionaryItem[];
	selectedType: Option<DictionaryItem>
}

export default class AssetSpecificationItemsView extends React.Component<Props, State> {
	private dictItems: DictionaryItem[];

	constructor(props: Props) {
		super(props);
		this.state = {selectedType: none, filteredDictItems: []};
		this.onAdd = this.onAdd.bind(this);
		this.onRemove = this.onRemove.bind(this);
		this.onValueChange = this.onValueChange.bind(this);
		this.renderAssetSpecification = this.renderAssetSpecification.bind(this)
	}

	componentWillMount() {
		this.dictItems = [
			new DictionaryItem(AssetSpecificationType.Height, AssetSpecificationLabel.Height),
			new DictionaryItem(AssetSpecificationType.Depth, AssetSpecificationLabel.Depth),
			new DictionaryItem(AssetSpecificationType.Width, AssetSpecificationLabel.Width),
			new DictionaryItem(AssetSpecificationType.Weight, AssetSpecificationLabel.Weight),
			new DictionaryItem(AssetSpecificationType.FlowRate, AssetSpecificationLabel.FlowRate),
			new DictionaryItem(AssetSpecificationType.HeatingOutput, AssetSpecificationLabel.HeatingOutput),
			new DictionaryItem(AssetSpecificationType.WaterTank, AssetSpecificationLabel.WaterTank),
			new DictionaryItem(AssetSpecificationType.WaterOutput, AssetSpecificationLabel.WaterOutput),
			new DictionaryItem(AssetSpecificationType.Efficiency, AssetSpecificationLabel.Efficiency),
			new DictionaryItem(AssetSpecificationType.SolarCompatible, AssetSpecificationLabel.SolarCompatible),
		];
		this.setState(
			{filteredDictItems: this.dictItems.filter(di => this.props.items.filter(s => di.id === s.type).length === 0)})
	}

	componentWillUnmount() {
		this.dictItems = [];
	}

	render() {
		return (
			<Fragment>
				<div className={"c-asset-specification"}>
					<div className={"c-asset-specification_criteria"}>
						<div className={"c-asset-specification_criteria_type"}>
							<SelectDictionaryItem clearable={false}
												  items={option(this.state.filteredDictItems)}
												  selectedId={this.state.selectedType.map(s => s.id)}
												  onChanged={(item: Option<DictionaryItem>) => {
													  this.setState({selectedType: item})
												  }}/>
						</div>
						<ButtonSecondary label={"Add specification"}
										 disabled={!this.state.selectedType.isDefined}
										 onClick={this.onAdd}/>
					</div>
					{this.props.items.map((item, index) => {
						return (
							<div key={index} className={"c-asset-specification_item"}>
								{this.renderAssetSpecification(item, index)}
								<div className={"c-asset-specification_item_remove"}>
									<IconLarge icon={Icon.X} onClick={() => this.onRemove(index)} variant={"scarlet"}/>
								</div>
							</div>
						);
					})}
				</div>

			</Fragment>
		)
	}

	onValueChange(index: number, value: Option<string>) {
		const items = this.props.items.map((item, idx) => idx == index ? item.copy({value: value.map(i => i).orNull}) : item);

		this.props.onChange(items);
	}

	onRemove(index: number) {
		const items = this.props.items.filter((item, idx) => index != idx);
		let filteredDictItems = this.dictItems.filter(di => items.filter(a => a.type == di.id).length == 0);
		this.setState({filteredDictItems}, () => {
			this.props.onChange(items);
		});
	}

	onAdd() {
		const items = this.props.items;
		let filteredDictItems = this.state.filteredDictItems;
		this.state.selectedType.map(s => {
			if (s.id === AssetSpecificationType.SolarCompatible) {
				items.push(AssetSpecification.createEmpty(s.id, s.name, "false"));
				filteredDictItems = this.state.filteredDictItems.filter(di => di.id != s.id)
			}
			else {
				items.push(AssetSpecification.createEmpty(s.id, s.name, ""));
				filteredDictItems = this.state.filteredDictItems.filter(di => di.id != s.id)
			}
		});

		this.setState({selectedType: none, filteredDictItems}, () => {
			this.props.onChange(items);
		});
	}

	renderAssetSpecification(item: AssetSpecification, index: number) {
		switch (item.type) {
			case AssetSpecificationType.Efficiency:
				return <AssetSpecificationEfficiencySelector key={index} item={item}
															 onChange={(value) => { this.onValueChange(index, value)}}/>;
			case AssetSpecificationType.SolarCompatible:
				return <AssetSpecificationBooleanSelector key={index} item={item}
														  onChange={(value) => { this.onValueChange(index, value)}}/>;
			default:
				return <AssetSpecificationTextSelector key={index} item={item}
													   onChange={(value) => { this.onValueChange(index, value)}}/>
		}
	}
}